var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-layout',{attrs:{"row":"","wrap":""}},_vm._l((_vm.data),function(code){return _c('v-flex',{key:code.value,attrs:{"xs2":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('qrcode',{attrs:{"value":code.value}})],1),_c('v-flex',{attrs:{"xs12":""}},[_c('h4',[_vm._v(_vm._s(code.name))])])],1)}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }